export function Spinner() {
  return (
    <div
      style={{
        width: 24,
        height: 24,
        border: "3px solid #e5e5e5",
        borderTop: "3px solid #f38020",
        borderRadius: "50%",
        animation: "spin 0.8s linear infinite",
        margin: "0 auto 8px",
      }}
    />
  );
}
